const ACTIVE_CLASS = "active";

class Loader {
	// @element - id of the loader or the loader itself (HTMLElement)
	constructor(element, color) {
		if (typeof element === "string") {
			this._$element = document.getElementById(`xyl-loader-${element}`);
		} else {
			this._$element = element;
		}

		if (color) {
			this._$element.classList.add(color);
		}
	}

	toggle() {
		this._$element.classList.toggle(ACTIVE_CLASS);
	}

	show() {
		this._$element.classList.add(ACTIVE_CLASS);
	}

	hide() {
		this._$element.classList.remove(ACTIVE_CLASS);
	}
}

export { ACTIVE_CLASS, Loader };
